// extracted by mini-css-extract-plugin
export var dropdownButton = "_2n-0";
export var fullWidthDropdownButton = "_2n-1";
export var icon = "_2n-3";
export var iconPlaceholder = "_2n-2";
export var menuItemRow = "_2n-8";
export var separator = "_2n-c";
export var shortcutContainer = "_2n-7";
export var shortcutIconLg = "_2n-6";
export var shortcutIconMd = "_2n-5";
export var shortcutIconSm = "_2n-4";
export var submenuChevron = "_2n-b";
export var submenuDropdown = "_2n-9";
export var submenuTriggerRow = "_2n-a";